import actionTypes from './actionTypes'
import config from '../../../config/config'
import { isSentry } from '../../../lib'

const {
  REQUEST_LOGIN,
  RECEIVE_LOGIN_STATUS,
  ERROR_OCURED,
  AUTH_ERRORS,
  FORET_PASS_ERROR,
  RESET_PASSWORD,
  SET_SHOULD_RESET,
  LOGIN_STATUS
} = actionTypes

function requestLogin() {
  return {
    type: REQUEST_LOGIN
  }
}

function hasErrored(bool) {
  return {
    type: ERROR_OCURED,
    hasErrored: bool
  }
}

export function getresponse(res, email, password, remember, dispatch) {
  if (res.status && res.status === 'success') {
    localStorage.setItem('loginEmail', email)
    localStorage.setItem('loginPassword', password)
    if (!remember) {
      sessionStorage.setItem('authToken', res.data.token)
      dispatch(recieveLoginstatus(true, res.data.user))
      dispatch(checkLoggedIn(true))
    } else {
      localStorage.setItem('authToken', res.data.token)
      dispatch(recieveLoginstatus(true, res.data.user))
      dispatch(checkLoggedIn(true))
    }
  } else if (res.errors) {
    dispatch(authErrors(res.errors))
    dispatch(checkLoggedIn(false))
  }
}

export function authErrors(errors) {
  return {type: AUTH_ERRORS, errors}
}

export function recieveLoginstatus(bool, user) {
  return {
    type: RECEIVE_LOGIN_STATUS,
    success: bool,
    user
  }
}

export function checkLoggedIn(bool) {
  return {
    type: LOGIN_STATUS,
    isLoggedIn: bool
  }
}

export function loginUser(email, password, remember) {
  return function (dispatch) {
    dispatch(requestLogin())
    const payload = {
      email,
      password
    }
    let myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json;charset=UTF-8')
    return fetch(`${config.URI}/api/v1/login`, {
      method: 'post',
      headers: myHeaders,
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        getresponse(res, email, password, remember, dispatch)
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })
  }
}

export function setShouldResetPassword(bool) {
  return {
    type: SET_SHOULD_RESET,
    shouldResetPassword: bool
  }
}

export function resetPassword(email) {
  return function (dispatch) {
    // dispatch(requestLogin());
    const payload = {
      email,
      service_name: 'webinar'
    }
    console.log(payload)
    let myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json;charset=UTF-8')
    return fetch(`${config.URI}/api/v1/password_reset`, {
      method: 'post',
      headers: myHeaders,
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch({type: RESET_PASSWORD})
        } else if (res.errors) {
          dispatch({type: FORET_PASS_ERROR})
        }
      })
      .catch((error) => {
        dispatch(hasErrored(true))
        isSentry(error)
      })

  }
}



// WEBPACK FOOTER //
// ./src/routes/Login/actions/index.js